export default __webpack_public_path__ + "8af0a5f352b75baf91141aea5d39af7d.png";